// Marks a live-search run, so a viewer does not compare its score against a direct run.
export function LiveSearchBadge() {
  return (
    <span className="shrink-0 rounded-full border border-primary/40 bg-primary/10 px-2 py-0.5 text-[10px] uppercase tracking-wider text-primary">
      Live search
    </span>
  )
}
